<template>
  <div class="modal-popup">
    <div class="modal fade" id="agencyPasswordPopup" tabindex="-1" role="dialog"  aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content" v-if="user != null">
          <div class="modal-header">
            <h5 class="modal-title title" v-if="user.id != null">Şifre Güncelle</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true" class="la la-close"></span>
            </button>
          </div>
          <div class="modal-body">
            <div class="contact-form-action d-flex justify-content-center">
              <form method="post" id="roomFrom" autocomplete="off">
                <div class="row col-12">
                  <base-edit-input
                      v-model="user.password"
                      :rules="'password'"
                      :type="'password'"
                      :label="'Şifre güncelle'">
                  </base-edit-input>
                </div>
              </form>
            </div>
          </div>
          <div class="modal-footer border-top-0 pt-0">
            <button type="button" class="btn font-weight-bold font-size-15 color-text-2 mr-2" data-dismiss="modal">
              İptal</button>
            <button  @click="updatePassword" type="button" class="theme-btn theme-btn-small">Güncelle</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BaseEditInput from "../base/BaseEditInput";
import validationFormUtils from "../../util/validationFormUtils";
import messagePopupManager from "../../util/messagePopupManager";

export default {
  name: "ChangePasswordPopup",
  components: {BaseEditInput},
  computed:{
    user:{
      get(){
        return this.$store.getters.getUser;
      }
    },
  },
  methods:{
    updatePassword(){
      if(this.formValid){
        this.$store.dispatch("changePassword", {
          newPassword : this.user.password,
          userId : this.user.id
        }).then(response => {
          $("#agencyPasswordPopup").modal('hide');
          messagePopupManager.showSuccess();
        })
      }
    },
  },
  watch:{
    user:{
      deep:true,
      handler:function () {
        validationFormUtils.checkFormFields(this);
      }
    }
  }
}
</script>

<style scoped>

</style>